module.exports = __webpack_public_path__ + "static/media/print.ffe16a10.svg";